/* istanbul ignore file */
var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled from 'styled-components';
import { Flex } from 'pcln-design-system';
import { Bed as BedIcon, Cars as CarsIcon, Cruises as CruisesIcon, Flights as FlightsIcon, Luggage as LuggageIcon } from 'pcln-icons';
import { CAR, CRUISE, FLIGHT, HOTEL, PACKAGE } from '../constants/productIcons';
var DEFAULT_ICON_SIZE = '40px';
var RoundFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ProductIcon__RoundFlex",
  componentId: "sc-xrhq1j-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 50%;\n  flex-shrink: 0;\n"], ["\n  border-radius: 50%;\n  flex-shrink: 0;\n"])));
function getIcon(type) {
  var _a;
  var props = (_a = {
    color: 'primary'
  }, _a['data-testid'] = 'product-icon-id', _a);
  switch (type) {
    case PACKAGE:
      return React.createElement(LuggageIcon, __assign({}, props));
    case HOTEL:
      return React.createElement(BedIcon, __assign({}, props));
    case FLIGHT:
      return React.createElement(FlightsIcon, __assign({}, props));
    case CAR:
      return React.createElement(CarsIcon, __assign({}, props));
    case CRUISE:
      return React.createElement(CruisesIcon, __assign({}, props));
  }
}
/** @public */
function ProductIcon(_a) {
  var _b = _a.alignItems,
    alignItems = _b === void 0 ? 'center' : _b,
    _c = _a.backgroundColor,
    backgroundColor = _c === void 0 ? 'background.lightest' : _c,
    type = _a.type,
    _d = _a.height,
    height = _d === void 0 ? DEFAULT_ICON_SIZE : _d,
    _e = _a.justifyContent,
    justifyContent = _e === void 0 ? 'center' : _e,
    _f = _a.width,
    width = _f === void 0 ? DEFAULT_ICON_SIZE : _f,
    props = __rest(_a, ["alignItems", "backgroundColor", "type", "height", "justifyContent", "width"]);
  return React.createElement(RoundFlex, __assign({
    alignItems: alignItems,
    color: backgroundColor,
    height: height,
    justifyContent: justifyContent,
    width: width
  }, props), getIcon(type));
}
export default ProductIcon;
var templateObject_1;